module.exports = __webpack_public_path__ + "img/car-miniature-person.a80801f7.jpg";